module.exports = __webpack_public_path__ + "static/media/20_tn.5d68db9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/20_tn.jpg
// module id = 158
// module chunks = 0